import React, { memo } from 'react';
import { Flex } from 'antd-mobile';
import PropTypes from 'prop-types';
import { ImgWrap } from 'pubBiz';
import styles from './index.modules.less';
import cx from 'classnames';

const defaultProps = {
  containerStyle: {},
  data: {},
  onPress: null
};

const propTypes = {
  containerStyle: PropTypes.object, // Object 容器样式
  width: PropTypes.any.isRequired, // Any 宽度 必传
  data: PropTypes.object, // Object 数据源
  onPress: PropTypes.func // Function 点击事件
};

const TitleCell = memo((props) => {
  const {
    containerStyle, // Object 容器样式
    width, // Any 宽度
    data, // Object 数据源
    onPress // Function 点击事件
  } = props;

  const { imgUrlApp, imgUrl, title, subTitle } = data;

  const imgBg = imgUrlApp || imgUrl;

  if (imgBg) {
    return (
      <Flex
        className={styles.container}
        style={containerStyle}
        onClick={() => onPress && onPress(data)}>
        <ImgWrap
          src={imgUrlApp || imgUrl}
          mode="cover"
          w={width}
          h="0.92rem"
          imgStyle={{
            visibility: imgUrlApp || imgUrl ? 'visible' : 'hidden'
          }}
        />
        <Flex
          direction="row"
          align="end"
          justify="between"
          className={cx(styles.contentContainer, styles.textContentContainer)}>
          <div className={styles.title}>
            <span>{title || ''}</span>
          </div>
          <div className={styles.subTitle}>
            <span>{subTitle || ''}</span>
          </div>
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex
      className={styles.container}
      style={containerStyle}
      onClick={() => onPress && onPress(data)}>
      <Flex direction="row" align="end" justify="between" className={styles.textContentContainer}>
        <div className={styles.title}>
          <span>{title || ''}</span>
        </div>
        <div className={styles.subTitle}>
          <span>{subTitle || ''}</span>
        </div>
      </Flex>
    </Flex>
  );
});

TitleCell.defaultProps = defaultProps;
TitleCell.propTypes = propTypes;

export default TitleCell;



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/TitleCell/index.js